import { jobBoardApi } from './jobBoardApi';
import { CreateJobRequest, JobDto, UpdateJobRequest } from '../types/jobBoard';

export const jobApi = {
  getJobs: () => jobBoardApi.getJobs(),
  getJob: (id: string) => jobBoardApi.getJob(id),
  createJob: (data: CreateJobRequest) => jobBoardApi.createJob(data),
  updateJob: (id: string, data: UpdateJobRequest) => jobBoardApi.updateJob(id, data),
  deleteJob: (id: string) => jobBoardApi.deleteJob(id),
};

export const JobApi = jobApi;
export type { JobDto };